<img *ngIf="imageBase64Promise | async as image; else placeholder"
    class="person-picture__{{iconSize}}"
    [ngClass]="{ 'person-picture-upcoming-meeting__display' : isUpcomingMeeting, 'person-picture__image' : !isUpcomingMeeting, 'person-picture__image--card': personPictureCard }"
    [src]="'data:image/png;base64,' + image"
    title="{{ person?.fullName }}"
    [ohpPeopleCard]="person?.email"/>
<div *ngIf="status === 'Accepted' || status === 'Declined' || status === 'TentativelyAccepted'">
    <ohp-icon-font [iconFontName]="status" cssClass='upcomingMeeting-card__attendee_status_image' size="16"></ohp-icon-font>
</div>

<ng-template #placeholder>
    <div *ngIf="isUpcomingMeeting"
         class="person-picture-upcoming-meeting__display"
         title="{{ person?.fullName }}"
         aria-hidden="true">
         <div class="person-picture-upcoming-meeting__text">
            {{ person?.fullName.slice(0,1) }}
         </div>
    </div>
    <div *ngIf="!isUpcomingMeeting"
        class="person-picture__image person-picture__image--icon"
        [ngClass]="{ 'person-picture__placeholder--padding--7' : hasPadding }"
        title="{{ person?.fullName }}"
        style="font-size: 24px;" aria-hidden="true">
        <ohp-icon-font iconFontName="Person" size="16"></ohp-icon-font>
    </div>
</ng-template>
